import { getLabelByValue, specialTypeDict, sendGoodsStatusDict, afterSaleStatusDict, unitDict } from '@/dicts';
import { dateRangeTmplItem } from '@/components/tableFormNew/common/dateItem';

// 销售订单列表-筛选项列表
const salesOrderFormList = [
    { type: 'input', label: '订单编号', prop: 'orderNo', placeholder: '请输入订单编号' },
    { type: 'select', label: '活动类型', prop: 'specialType', options: specialTypeDict },
    { type: 'input', label: '活动编号', prop: 'activitySn', placeholder: '请输入活动编号' },
    { type: 'input', label: '活动名称', prop: 'activityName', placeholder: '请输入活动名称' },
    { type: 'input', label: '商品名称', prop: 'productName', placeholder: '请输入商品名称' },
    { type: 'input', label: '门店信息', prop: 'storeName', placeholder: '请输入门店名称/联系人/联系方式' },
    {
        type: 'select',
        label: '支付状态',
        prop: 'payStatus',
        options: [
            { value: 1, label: '已完成支付' },
            { value: 2, label: '未完成支付' },
        ],
    },
    { type: 'select', label: '发货状态', prop: 'sendGoodsStatus', options: sendGoodsStatusDict },
    { type: 'select', label: '售后状态', prop: 'afterSaleStatus', options: afterSaleStatusDict },
    {
        ...dateRangeTmplItem,
        label: '下单时间',
        prop: ['startTime', 'endTime'],
        isJoinTimeSuffix: true,
    },
    {
        type: 'custom',
        label: '最近活动',
        prop: 'activeIds',
        placeholder: '-',
        customComponent: 'RecentlyActivity',
        value: [],
    },
];

// 销售订单列表-表头
const salesOrderColumns = [
    {
        title: '商品信息',
        align: 'center',
        minWidth: 330,
        resizable: true,
        percentage: '25%',
        lg: 6,
    },
    {
        title: '单价/下单数量',
        align: 'center',
        minWidth: 100,
        percentage: '15%',
        lg: 3,
    },
    {
        title: '入库/活动',
        align: 'center',
        minWidth: 200,
        percentage: '15%',
        lg: 3,
    },
    {
        title: '收款信息',
        align: 'center',
        minWidth: 200,
        percentage: '15%',
        lg: 4,
    },
    {
        title: '门店信息',
        align: 'center',
        minWidth: 250,
        width: 250,
        resizable: true,
        percentage: '15%',
        lg: 5,
        render: (h, { row }) => {
            return h('div', [
                h('p', { class: 'order-item-column store-info' }, '门店名称：' + row.storeName),
                h('p', { class: 'order-item-column store-info' }, '门店联系人：' + row.ownerName),
                h('p', { class: 'order-item-column store-info' }, '门店联系方式：' + row.ownerPhone),
                h('p', { class: 'order-item-column store-info' }, '经销商：' + row.distributorName),
            ]);
        },
    },
    {
        title: '操作',
        align: 'center',
        minWidth: 160,
        percentage: '15%',
        lg: 3,
    },
];

// 商品基础 表头
const baseProductColumns = [
    { title: '商品名称', key: 'productName', minWidth: 180 },
    {
        title: '商品组商品',
        minWidth: 180,
        render: (h, { row }) => {
            const list = row.groupProductNameList || [];
            return list.length ? list.map((item) => h('div', item)) : '-';
        },
    },
    {
        title: '单位',
        key: 'unit',
        align: 'center',
        minWidth: 80,
        render: (h, p) => [getLabelByValue(unitDict, p.row.unit, 'specialLabel')],
    },
    {
        title: '单价',
        key: 'amount',
        minWidth: 100,
        render: (h, p) => {
            return h('div', [
                h('p', p.row.discountedPrice || p.row.amount),
                p.row.discountedPrice
                    ? h(
                          'p',
                          {
                              style: {
                                  color: '#999',
                                  textDecoration: 'line-through',
                              },
                          },
                          p.row.amount,
                      )
                    : '',
            ]);
        },
    },
    {
        title: '定金',
        key: 'payDeposit',
        minWidth: 80,
        render: (h, p) => {
            return h('div', p.row.payDeposit == null ? '-' : p.row.payDeposit);
        },
    },
    { title: '数量', key: 'quantity', minWidth: 80 },
    { title: '金额', key: 'total', minWidth: 80 },
    {
        title: '返利',
        minWidth: 150,
        render: (h, p) => {
            return h('div', { style: 'min-width:120px;' }, [
                p.row.sendGoodsQuantity ? h('p', `发货：${p.row.sendGoodsQuantity}`) : '',
                h('p', `入库：${p.row.inTimes || 0}`),
                p.row.cashBack ? h('p', `特价返利：${p.row.cashBack || 0}元*${p.row.quantity || 0}`) : '',
            ]);
        },
    },
    {
        title: '标签',
        minWidth: 150,
        render: (h, p) => [p.row.label || '-'],
    },
    {
        title: '赠品名称',
        minWidth: 150,
        render: (h, p) => {
            const list = JSON.parse(p.row.gift || '[]');
            return [list.map((k) => k.name).join(';') || '-'];
        },
    },
    {
        title: '活动',
        minWidth: 180,
        render: (h, p) => {
            return h('div', { style: 'min-width:120px;' }, [
                h('p', `活动编号：${p.row.activitySn || '-'}`),
                h('p', `活动名称：${p.row.activityName || '-'}`),
            ]);
        },
    },
    {
        title: '区域补贴',
        minWidth: 100,
        render: (h, p) => [p.row.regionalSubsidyPrice || '-'],
    },
];

// 线上商品 表头
const onLineColumns = [
    ...baseProductColumns.slice(0, 7),
    {
        title: '已退数量',
        minWidth: 100,
        render: (h, p) => [p.row.hasRefundNum || '-'],
    },
    {
        title: '已退金额',
        minWidth: 100,
        render: (h, p) => [p.row.hasRefundAmount || '-'],
    },
    ...baseProductColumns.slice(7),
];

const refundColumns = [
    { title: '退款单号', key: 'refundOrderNo', minWidth: 205 },
    { title: '退款发起时间', key: 'startTime', minWidth: 170 },
    {
        title: '退款完成时间',
        minWidth: 170,
        render: (h, p) => [p.row.successTime || '-'],
    },
    { title: '支付方式', key: 'payTypeStr', minWidth: 100 },
    { title: '退款总金额', key: 'totalAmount', minWidth: 120 },
    {
        title: '返利退款',
        minWidth: 120,
        render: (h, p) => {
            return [p.row.rebateRefundAmount === null ? '-' : p.row.rebateRefundAmount];
        },
    },
    {
        title: '授信退款',
        minWidth: 120,
        render: (h, p) => {
            return [p.row.creditRefundAmount === null ? '-' : p.row.creditRefundAmount];
        },
    },
    {
        title: '三方支付退款',
        minWidth: 120,
        render: (h, p) => {
            return [p.row.cpcnRefundAmount === null ? '-' : p.row.cpcnRefundAmount];
        },
    },
    { title: '退款状态', key: 'refundStatusStr', minWidth: 120 },
    {
        title: '交易流水号',
        minWidth: 200,
        render: (h, p) => [p.row.txSn || '-'],
    },
    {
        title: '备注',
        minWidth: 120,
        render: (h, p) => {
            const str = p.row.returnType === 1 || p.row.refundStatus == '30' ? p.row.remark : '-';
            return [str];
        },
    },
];

export { salesOrderFormList, salesOrderColumns, baseProductColumns, onLineColumns, refundColumns };
